/**
 * Normalize AI recap list entries for UI: strings pass through; structured
 * action-item objects (owner/action/intent/timeline) become readable text.
 */
export function formatAiRecapBullet(item) {
  if (item === null || item === undefined || item === "") return "";
  const t = typeof item;
  if (t === "string" || t === "number") return String(item);
  if (t === "boolean") return item ? "Yes" : "No";
  if (Array.isArray(item)) {
    return item.map(formatAiRecapBullet).filter(Boolean).join("; ");
  }
  if (t === "object") {
    const owner = item.owner != null ? String(item.owner).trim() : "";
    const action = item.action != null ? String(item.action).trim() : "";
    const intent = item.intent != null ? String(item.intent).trim() : "";
    const timeline = item.timeline != null ? String(item.timeline).trim() : "";
    let head = "";
    if (owner && action) head = `${owner}: ${action}`;
    else head = action || owner || "";
    const extras = [];
    if (intent) extras.push(intent);
    if (timeline) extras.push(timeline);
    const tail = extras.length ? ` (${extras.join(" · ")})` : "";
    const out = `${head}${tail}`.trim();
    if (out) return out;
    try {
      return JSON.stringify(item);
    } catch {
      return String(item);
    }
  }
  return String(item);
}
